<div class="main-controls structure-control">
    <div
        class="btn-group"
        dropdown
        (onShown)="isShowDropDownMenu(true)"
        (onHidden)="isShowDropDownMenu(false)"
        container="body"
    >
        <button class="btn-control btn-sm dropdown-toggle row-control" dropdownToggle type="button">
            <span class="sp-icon icon-option-horizontal"> </span>
            <small>{{ "control_structure" | translate }}</small>
        </button>
        <ul *dropdownMenu class="dropdown-menu structure-dropdown-menu" role="menu">
            <li role="menuitem">
                <a class="dropdown-item" (click)="selectAction()">
                    <span class="sp-icon icon-pencil"> </span>
                    {{ "edit" | translate }}
                </a>
            </li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="copyAction()">
                    <span class="sp-icon icon-copy"> </span>
                    {{ "duplicate" | translate }}
                </a>
            </li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="addAction()">
                    <span class="sp-icon icon-add"> </span>
                    {{ "control_add_widget_or_structure" | translate }}
                </a>
            </li>
            <li><hr /></li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="deleteAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
